import {createContext, FC, ReactNode, useContext, useState} from 'react'

const ListViewContext = createContext<{
  selected: Array<string>
  itemIdForUpdate: string | undefined
  setItemIdForUpdate: (id: string | undefined) => void
  setSelected: (ids: Array<string>) => void
}>({
  selected: [],
  itemIdForUpdate: undefined,
  setItemIdForUpdate: () => {},
  setSelected: () => {},
})

const ListViewProvider: FC<{children: ReactNode}> = ({children}) => {
  const [selected, setSelected] = useState<Array<string>>([])
  const [itemIdForUpdate, setItemIdForUpdate] = useState<string | undefined>(undefined)

  return (
    <ListViewContext.Provider
      value={{
        selected,
        itemIdForUpdate,
        setItemIdForUpdate,
        setSelected,
      }}
    >
      {children}
    </ListViewContext.Provider>
  )
}

const useListView = () => useContext(ListViewContext)

export {ListViewProvider, useListView}

